<template>
  <b-modal id="modal-config-positions" v-model="modal" size="lg" hide-footer>
    <template #modal-title>CONFIGURAR OPERADORES</template>
    <Multiselect
      :options="options"
      v-model="values"
      @remove="handleRemove"
      multiple
      label="name"
      track-by="name"
    />
    <div class="d-flex">
      <vs-button type="button" success @click="save"> GUARDAR </vs-button>
    </div>
  </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      modal: false,
      tournament: null,
      values: [],
      options: [
        {
          name: 'Vue.js',
          operator: 'JavaScript',
        },
        {
          name: 'Adonis',
          operator: 'JavaScript',
        },
        {
          name: 'Rails',
          operator: 'Ruby',
        },
        {
          name: 'Sinatra',
          operator: 'Ruby',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      success: 'tournaments/isSuccess',
      message: 'tournaments/getMessage',
    }),
  },
  methods: {
    async save() {
      const values = this.values.filter((el) => !el.id);

      await this.assignOperator({
        values,
        tournament: this.tournament,
      });

      console.log('this.success', this.success);
      if (!this.success)
        return this.$swal.fire({ title: 'Error agregando operadores' });

      this.$swal.fire({ title: 'Operadores agregados' });
      this.modal = false;
    },
    async handleRemove(value) {
      const { isConfirmed } = await this.$swal.fire({
        title: 'Estas seguro de eliminar el operador?',
        showConfirmButton: true,
        showDenyButton: true,
      });

      const copyRemoved = JSON.parse(JSON.stringify(value));

      if (!isConfirmed) {
        this.values.push(copyRemoved);
        return;
      }

      await this.removeOperator({ id: value.id });

      if (!this.success) this.values.push(copyRemoved);
      this.$swal.fire({ title: this.message });
    },
    ...mapActions({
      assignOperator: 'tournaments/assignOperator',
      removeOperator: 'tournaments/removeOperator',
    }),
  },
};
</script>

<style lang="scss" scoped></style>
